import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const shippingLineService = {
  async getShippingLines(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/shipping-lines", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getShippingLineById(id) {
    if (!id) throw new Error("Shipping Line ID is required");

    try {
      const response = await apiClient.get(`/shipping-lines/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createShippingLine(data) {
    try {
      const response = await apiClient.post("/shipping-lines", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateShippingLine(id, data) {
    if (!id) throw new Error("Shipping Line ID is required");

    try {
      const response = await apiClient.patch(`/shipping-lines/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteShippingLine(id) {
    if (!id) throw new Error("Shipping Line ID is required");

    try {
      const response = await apiClient.delete(`/shipping-lines/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveShippingLines() {
    try {
      const response = await apiClient.get("/shipping-lines/active");
      const payload = response?.data || {};
      const items = toArray(payload?.data || payload);

      return {
        items,
        meta: {
          page: 1,
          limit: items.length,
          total: items.length,
          totalPages: 1,
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default shippingLineService;
